<script>
  export let hidden;
  export let label;
  export let buttonId;
  export let dataClear = false;
</script>

<button
  type="button"
  class="border-0 bttn bttn-sm poppins-font mx-1 px-2 right-0 top-0"
  class:d-none={hidden}
  data-testid="availability-clear-{buttonId}"
  data-clear={dataClear}
  on:click>
  <svg
    class="v-align-baseline"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 37 37"
    width="10"
    height="10"
    aria-hidden="true"
    focusable="false"
    ><path
      fill-rule="evenodd"
      d="M35.031 35.484c-.7.7-1.52 1.05-2.462 1.05-.941 0-1.762-.35-2.461-1.05L18 23.377 5.892 35.484c-.7.7-1.506 1.05-2.421 1.05-.915 0-1.722-.35-2.422-1.05C.35 34.784 0 33.977 0 33.063c0-.915.35-1.722 1.05-2.422l12.107-12.107L1.049 6.345C.35 5.645 0 4.84 0 3.924c0-.915.35-1.722 1.05-2.422.699-.7 1.506-1.05 2.42-1.05.916 0 1.723.35 2.422 1.05L18 13.61 30.188 1.502c.7-.7 1.507-1.05 2.422-1.05.915 0 1.722.35 2.421 1.05.7.7 1.05 1.507 1.05 2.422 0 .915-.35 1.722-1.05 2.421L22.843 18.534 35.031 30.64c.7.7 1.05 1.507 1.05 2.422 0 .914-.35 1.722-1.05 2.421z" /></svg>
  <span class="sr-only">Clear {label}</span>
</button>
